/**
 * @author Harshitha.k
 * @description
 */

import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import moment from 'moment';
import { Button, Input, Tabs, Tag } from 'antd';
import Highlighter from 'react-highlight-words';
import { SearchOutlined, DashboardOutlined } from '@ant-design/icons';
import localStorage from '../../utils/localStorage';
import ReportTable from './ReportTable';
import { reportTableCall } from './ReportCalls';

const Reports = (props) => {
  const [state, setState] = useState({
    reportName: '',
    reportJSON: [],
    currentTab: '',
    tabPosition: 'top',
    selectedThemeing: props.selectedThemeing,
    selectedTheme: props.selectedTheme
  });
  const [searchText, setSearchText] = useState('');
  const [language, setLanguage] = useState(localStorage.get('currentLanguage') || 'English');
  const searchInput = useRef(null);

  const hookParams = useParams();
  const hookLocation = useLocation();

  const params =
    Object.keys(hookParams).length && hookParams.report
      ? hookParams
      : props.match
      ? props.match.params
      : {};
  const location = hookLocation && hookLocation.search ? hookLocation : props.location || {};

  useEffect(() => {
    const reportName = params.report;
    const reportType = params.reportType;
    getReportJSON(reportName, reportType);
  }, [props.params]);

  const getReportJSON = async (reportName, reportType) => {
    try {
      console.log('ttttt get report triggerd');
      const reportJSON = await reportTableCall(reportName, reportType);
      const reportObject = await tableColumnAdapter(reportJSON);

      setState((prevState) => ({
        ...prevState,
        reportName,
        reportJSON: reportObject,
        currentTab: reportJSON.length > 0 ? reportJSON[0].TabName : ''
      }));
    } catch (error) {
      console.error('Error fetching report JSON:', error);
    }
  };

  const tableColumnAdapter = async (reportJSON) => {
    if (
      reportJSON &&
      Array.isArray(reportJSON) &&
      Object.entries(reportJSON).length !== 0 &&
      !reportJSON.stack
    ) {
      await Promise.all(
        reportJSON.map(async (reportItem, key) => {
          let { JSON } = reportItem;
          if (JSON && JSON.columns) {
            let children = [];
            await Promise.all(
              JSON.columns.map(async (columnsItem, key1) => {
                let styleObj = {
                  textAlign: JSON.tableConfiguration?.style?.textAlign || 'center',
                  evenRowColor:
                    JSON.tableConfiguration?.style?.evenRowColor || 'rgb(251, 250, 250)',
                  oldRowColor: JSON.tableConfiguration?.style?.oldRowColor || '#fff',
                  colSpan: JSON.tableConfiguration?.style?.colSpan || []
                };
                if (JSON.tableConfiguration?.style?.colSpan?.length > 0) {
                  let colSpanObject = JSON.tableConfiguration.style.colSpan;
                  await Promise.all(
                    colSpanObject.map(async (colSpan) => {
                      if (
                        columnsItem.key === colSpan.columnKey ||
                        (key1 !== 0 ? JSON.columns[key1 - 1].key === colSpan.columnKey : false)
                      ) {
                        // let column = await getGenerateColSpanJSON(columnsItem, styleObj, colSpan);
                        // reportJSON[key].JSON.columns[key1] = column;
                      } else {
                        let column = await getGenerateJSON(columnsItem, styleObj);
                        reportJSON[key].JSON.columns[key1] = column;
                      }
                    })
                  );
                } else {
                  if (columnsItem.children) {
                    children = columnsItem.children.map((child) => {
                      return getGenerateJSON(child, JSON.tableConfiguration.style);
                    });
                    reportJSON[key].JSON.columns[key1].title = reportJSON[key].JSON.columns[key1]
                      .process ? (
                      <div>
                        <span style={{ marginRight: '10px' }}>
                          {reportJSON[key].JSON.columns[key1].title}
                        </span>
                        <DashboardOutlined
                          onClick={() => {
                            // openDashboard(reportJSON[key].JSON.columns[key1]);
                          }}
                          style={{ cursor: 'pointer' }}
                        />
                      </div>
                    ) : (
                      reportJSON[key].JSON.columns[key1].title
                    );
                    reportJSON[key].JSON.columns[key1].children = children;
                  } else {
                    let column = await getGenerateJSON(columnsItem, styleObj);
                    reportJSON[key].JSON.columns[key1] = column;
                  }
                }
              })
            );
          }
        })
      );
    }
    return reportJSON;
  };
  const getPlusThreeNumbersUntilTotal = (start, total, span) => {
    let result = [];
    let current = start;

    while (current <= total) {
      result.push(current);
      current += span;
    }

    return result;
  };
  const getGenerateJSON = (columns, tableConfig) => {
    const { textAlign, fontWeight } = tableConfig;
    const generateColumn = (column) => {
      if (column && column.key === 'Status') {
        return {
          ...column,
          ...(column.colSpanProp && column.colSpanProp.show === true
            ? {
                onCell: (_, index) => {
                  let totalList = getPlusThreeNumbersUntilTotal(
                    0,
                    column.colSpanProp ? column.colSpanProp.totalRows : 100,
                    column.colSpanProp ? column.colSpanProp.span : 0
                  );
                  return {
                    rowSpan: totalList.includes(index)
                      ? column.colSpanProp
                        ? column.colSpanProp.span
                        : 0
                      : 0
                  };
                }
              }
            : {}),
          onFilter: (value, record) =>
            record[column.key] && record[column.key].indexOf(value) === 0,
          ...(column.rowFilter ? getColumnSearchProps(column.key) : {}),
          render(text, record) {
            return {
              children: (
                <div style={{ textAlign: 'center' }}>
                  {record && record.Color ? (
                    <Tag color={record.Color}>{text}</Tag>
                  ) : (
                    <div>{text}</div>
                  )}
                </div>
              )
            };
          }
        };
      } else if (column && column.isUTC) {
        return {
          ...column,
          ...(column.colSpanProp && column.colSpanProp.show === true
            ? {
                onCell: (_, index) => {
                  let totalList = getPlusThreeNumbersUntilTotal(
                    0,
                    column.colSpanProp ? column.colSpanProp.totalRows : 100,
                    column.colSpanProp ? column.colSpanProp.span : 0
                  );
                  return {
                    rowSpan: totalList.includes(index)
                      ? column.colSpanProp
                        ? column.colSpanProp.span
                        : 0
                      : 0
                  };
                }
              }
            : {}),
          render(text) {
            return {
              children: (
                <div>
                  {text && text !== 'Total'
                    ? moment.utc(text).local().format('YYYY-MM-DD HH:mm:ss')
                    : text}
                </div>
              )
            };
          }
        };
      } else {
        return {
          ...column,
          onFilter: (value, record) =>
            record[column.key] && record[column.key].indexOf(value) === 0,
          ...(column.rowFilter ? getColumnSearchProps(column.key) : {}),
          ...(column.colSpanProp && column.colSpanProp.show === true
            ? {
                onCell: (_, index) => {
                  let totalList = getPlusThreeNumbersUntilTotal(
                    0,
                    column.colSpanProp ? column.colSpanProp.totalRows : 100,
                    column.colSpanProp ? column.colSpanProp.span : 0
                  );
                  return {
                    rowSpan: totalList.includes(index)
                      ? column.colSpanProp
                        ? column.colSpanProp.span
                        : 0
                      : 0
                  };
                }
              }
            : {}),
          render(text, record) {
            return {
              props: {
                style: { background: record && record.color ? record.color : column.background }
              },
              children: <div style={{ textAlign, fontWeight }}>{text !== 'null' ? text : ''}</div>
            };
          }
        };
      }
    };
    return generateColumn(columns);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          type="primary"
          danger
          onClick={() => handleReset(clearFilters, confirm)}
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const callback = (currentTab) => {
    setState((prevState) => ({ ...prevState, currentTab }));
  };

  const queries = queryString.parse(location.search);
  const { reportJSON } = state;

  const items = reportJSON.map((tab) => ({
    key: tab.TabName,
    label: tab.TabName,
    children: tab.JSON ? <ReportTable {...tab} /> : null
  }));

  const LanguageChange = (lang) => {
    setLanguage(lang);
  };

  return (
    <div style={{ margin: '5px', padding: '30px' }}>
      {reportJSON && reportJSON.length > 1 ? (
        <Tabs
          tabPosition={state.tabPosition}
          onChange={callback}
          items={items}
          CurrentLanguage={language}
          onChangeLang={LanguageChange}
        />
      ) : (
        <div>
          {reportJSON && reportJSON[0] && (
            <ReportTable
              {...{
                ...reportJSON[0].JSON,
                ...queries
              }}
              CurrentLanguage={language}
              onChangeLang={LanguageChange}
            />
          )}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  selectedThemeing: state.ThemeReducer.selectedThemeing,
  selectedTheme: state.ThemeReducer.selectedTheme
});

export default connect(mapStateToProps)(Reports);
